import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { variables } from "../variables";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    height: 35,
  },
});

const PdfTableBlankSpace = ({ data, rowsCount, dataLength, customStyle }) => {
  const row = data.length > 0 && data[0];
  if (rowsCount < 0) return null;
  const blankRows = Array(rowsCount).fill(0);
  const rows = blankRows.map((x, i) => {
    const className = { ...styles.row };

    if (dataLength % 2) {
      !(i % 2) && (className.backgroundColor = variables.stripedColor);
    } else {
      i % 2 && (className.backgroundColor = variables.stripedColor);
    }

    return (
      <View style={className} key={`BR${i}`}>
        {Object.keys(row).map((itm) => (
          <Text style={[styles[itm], customStyle["blankSpace"][itm]]}>-</Text>
        ))}
      </View>
    );
  });
  return <Fragment>{rows}</Fragment>;
};

export default PdfTableBlankSpace;